

export const WineText = ({text}: {text: string}) => {
    return <div style={{whiteSpace: "pre-wrap"}}>{text}</div>
}
